module.exports = __webpack_public_path__ + "static/media/oetker-logo.1accdbb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/oetker-logo.svg
// module id = 301
// module chunks = 0